import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { APP_CONFIG, ENVIRONMENT_COLORS, EnvironmentColorKey } from '../../config/constants';

interface EnvironmentBadgeProps {
  environment?: string;
  version?: string;
}

const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({
  environment = APP_CONFIG.ENVIRONMENT,
  version = APP_CONFIG.VERSION,
}) => {
  const theme = useTheme();

  // Determine badge color based on environment
  const getBadgeColor = () => {
    const env = environment.toLowerCase() as EnvironmentColorKey;
    return ENVIRONMENT_COLORS[env] || ENVIRONMENT_COLORS.dev;
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Chip
        label={environment}
        size="small"
        sx={{
          backgroundColor: getBadgeColor(),
          color: theme.palette.common.white,
          fontWeight: 600,
          fontSize: '11px',
          height: '22px',
          '& .MuiChip-label': {
            padding: '0 8px',
          },
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 500,
          fontSize: '11px',
        }}
      >
        {version}
      </Typography>
    </Stack>
  );
};

export default EnvironmentBadge;
